import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Modal from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import closeMediumTokens from '@amzn/meridian-tokens/base/icon/close-medium';
import { observer } from 'mobx-react-lite';
import React from 'react';

import googlePlayQR from '../../assets/googlePlayQR.svg';
import { SidebarContent } from '../../constants/SideBarConstants';
import { sidebarStore } from '../../store/SidebarStore';

const QRScanner = () => {
  const handleToggle = () => {
    sidebarStore.handleScannerToggle();
  };

  return (
    <Modal open={sidebarStore.scannerToggle}>
      <Column spacing="none" spacingInset="none">
        <Row alignmentHorizontal="justify">
          <Text>{SidebarContent.googlePlayScanner}</Text>
          <Button type="icon" onClick={handleToggle} data-testid="modal">
            <Icon tokens={closeMediumTokens}></Icon>
          </Button>
        </Row>
        <img src={googlePlayQR} alt="google-play-QR" />
      </Column>
    </Modal>
  );
};

export default observer(QRScanner);
